import { Layout } from "antd";
import styled from "styled-components";
export const SiderWrapper = styled(Layout.Sider)`
  z-index: 1001;
  position: sticky !important;
  top: 0;
  height: calc(100vh - 3rem);
  overflow: hidden;

  padding: 0.05rem 0;
  font-size: 0.9rem;
  /* Anchor the collapse trigger to the sider instead of the viewport. antd
     defaults it to position: fixed; bottom: 0, which only lines up with the
     sider's bottom edge when nothing (e.g. BetaBanner) sits above the header. */
  .ant-layout-sider-trigger {
    position: absolute;
  }
  .ant-layout-sider-children {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
    background: #001529;
    /* Room to scroll the last menu item clear of the collapse trigger. antd
       normally reserves this via padding-bottom on .ant-layout-sider-has-trigger,
       but the padding shorthand above resets it. Keeping the reserve inside
       this element means the dark background covers it. */
    padding-bottom: 48px;
    .ant-menu {
      border-inline-end: 0;
    }
  }
`;
